<template>
  <div class="boardCommittee">
      <Header></Header>
      <div class="container">
          <div class="main_wrapper">
              <h1  data-aos="fade-up">{{this.data.brc.heading}}</h1>
              <p  data-aos="fade-up"><span class="seaGreen"> {{$t('labels.formed')}}</span> {{this.data.brc.Formed}}</p>
              <p data-aos="fade-up"><span class="seaGreen">{{$t('labels.term')}}</span> {{this.data.brc.Term}}</p>
              <p data-aos="fade-up"> <span class="seaGreen bold" >{{$t('labels.responsibility')}}</span> </p>
              <p v-for="(text,index) in this.data.brc.Responsibilities" :key="index+'c2g4'"  data-aos="fade-up">
                {{text}}
              </p>
              <p  data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.brcAch')}}</span></p>
              <ul>
                  <li v-for="(text,index) in this.data.brc.achievements" :key="index+'v2c4fg'" data-aos="fade-up">{{text}}</li>
              </ul>
              <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.cMember')}}</span></p>
              <p v-for="(text, index) in this.data.brc.committee_members" :key="index+'v26scg4g'" data-aos="fade-up">{{text}}</p>
              <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.note')}}</span></p>
              <ul>
                  <li v-for="(text,index) in this.data.brc.notes" :key="index+'6c5s3fs'" data-aos="fade-up">{{text}}</li>
              </ul>

              <p data-aos="fade-up"><strong>{{this.data.brc.noOfMembers}}</strong></p>
                <BrcTable />
            <ul class="attendance-status">
                <li  data-aos="fade-up" class="text-dark">
                    <span><img src="@/assets/images/svg/tik.svg" alt=""></span>
                    {{$t('labels.attended')}}
                </li>
                <li data-aos="fade-up" class="text-dark">
                    <span><img src="@/assets/images/svg/minus.svg" alt=""></span>
                    {{$t('labels.nApplicable')}}
                </li>
                <li data-aos="fade-up" class="text-dark">
                    <span><img src="@/assets/images/svg/cross.svg" alt=""></span>
                    {{$t('labels.absent')}}
                </li>
            </ul>
            <h2 data-aos="fade-up" class="mt-50">{{this.data.bac.heading}}</h2>
            <p data-aos="fade-up"><span class="seaGreen">{{$t('labels.formed')}}</span>{{this.data.bac.Formed}}</p>
            <p data-aos="fade-up"><span class="seaGreen">{{$t('labels.term')}}</span>{{this.data.brc.Term}}</p>
           <p data-aos="fade-up"> <span class="seaGreen bold" >{{$t('labels.responsibility')}}</span> </p>
            <p data-aos="fade-up">{{this.data.bac.Responsibilities.discription}}</p>
            <ol>
                <li v-for="(text,i) in this.data.bac.Responsibilities.listing" :key="i+'5c24fsg65' + i" data-aos="fade-up">
                    {{text}}
                </li>
            </ol>
            <p data-aos="fade-up">
                {{this.data.bac.Responsibilities.text}}
            </p>
            <p class="seaGreen bold" data-aos="fade-up">{{$t('labels.brcAch')}}</p>
            <ul>
                <li v-for="(text,index) in this.data.bac.achievements" :key="index+'c65f34'" data-aos="fade-up">{{text}}</li>
            </ul>
            <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.cMember')}}</span></p>
            <p v-for="(text, index) in this.data.bac.committee_members" :key="index+'22f6asd5f24'" data-aos="fade-up">{{text}}</p>
            <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.note')}}</span></p>
              <ul>
                  <li v-for="(text,index) in this.data.bac.notes" :key="index+'5dsa63ff'" data-aos="fade-up">{{text}}</li>
              </ul>
             <p data-aos="fade-up"><strong>{{this.data.bac.noOfMembers}}</strong></p>
               <BacTable />

                <ul class="attendance-status">
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/tik.svg" alt=""></span>
                         {{$t('labels.attended')}}
                    </li>
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/minus.svg" alt=""></span>
                        {{$t('labels.nApplicable')}}
                    </li>
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/cross.svg" alt=""></span>
                        {{$t('labels.absent')}}
                    </li>
                </ul>

                <h2 data-aos="fade-up">{{this.data.bnrc.heading}}</h2>
                <p data-aos="fade-up"><span class="seaGreen">{{$t('labels.formed')}}</span> {{this.data.bnrc.Formed}}</p>
                <p data-aos="fade-up"><span class="seaGreen">{{$t('labels.term')}}</span> {{this.data.bnrc.Term}}</p>
                <p data-aos="fade-up"> <span class="seaGreen bold" >{{$t('labels.responsibility')}}</span> </p>
                <p v-for="(text,index) in this.data.bnrc.Responsibilities" :key="index+'c4a2dadsf'" data-aos="fade-up">
                {{text}}
                </p>
                <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.brcAch')}}</span></p>
                <ul>
                  <li v-for="(text,index) in this.data.bnrc.achievements" :key="index+'6c35f'" data-aos="fade-up">{{text}}</li>
                </ul>
                <p data-aos="fade-up"><span class="seaGreen bold">{{$t('labels.cMember')}}</span></p>
                <p v-for="(text, index) in this.data.bnrc.committee_members" :key="index+'3c6da5fd'" data-aos="fade-up">{{text}}</p>
                <p data-aos="fade-up" v-if="$i18n.locale=='en'"><span class="seaGreen bold" >{{$t('labels.pmember')}}</span></p>
                <p data-aos="fade-up">{{this.data.bnrc.previous_members}}</p>

                <p data-aos="fade-up"><strong>{{this.data.bnrc.cMember}}</strong></p>
                <div class="table-wrapper" >
                <NominationTable />
                <ul class="attendance-status marks">
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/tik.svg" alt=""></span>
                       {{$t('labels.attended')}}
                    </li>
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/minus.svg" alt=""></span>
                       {{$t('labels.nApplicable')}}
                    </li>
                    <li data-aos="fade-up" class="text-dark">
                        <span><img src="@/assets/images/svg/cross.svg" alt=""></span>
                        {{$t('labels.absent')}}
                    </li>
                </ul>
                </div>
                <h4 class="gray" data-aos="fade-up">{{this.data.bnrc.releationShip}}</h4>
                <p v-for="(text,index) in this.data.bnrc.contents" :key="index+'265dfdg'" data-aos="fade-up">{{text}}</p>
          </div>
      </div>
  </div>
</template>

<script>
import data from "@/components/governance/json/BRC.json";
import BrcTable from "@/components/boardOfDirectors/boardCommitte/BrcTable.vue";
import BacTable from "@/components/boardOfDirectors/boardCommitte/BacTable.vue";
import NominationTable from "@/components/boardOfDirectors/boardCommitte/NominationTable.vue";

const brc = [];
const bac = [];
const bnrc =[];
export default {
    components:{
        BrcTable,
        BacTable,
        NominationTable
        // sctionsScroll
    },
    created(){
        
        this.$i18n.locale=="en" ? 
            this.data = data.en :
            this.data = data.ar;
        
    },

}
</script>
<style lang="scss">
    [data-page="board-committee"]{
        .verticalLabel{
            color:#707070;
        }
    }
</style>
<style lang="scss" scoped>

.boardCommittee{
    background: #E8E8E8; 
    overflow:hidden;
    padding-bottom:rem(30px);
    .main_wrapper{
        margin-top: 100px;
        .medium{
            max-width: 800px; 
            margin-left: auto !important;
            margin-right: auto !important;
            /deep/{
                .trow > {
                    div:first-child{
                        width:50%;
                    }
                }
            }
        }
        .custom-table {
            margin: rem(30px) 0;
            display: table;
            table-layout: fixed;
            width: 100%;
            .table-heading {
                background: #dedfe0;
                color: #00a982;
                font-size: 25px;
                font-weight: 600;
                padding: 10px;
                border-top: 1px solid #000;
                border-bottom: 1px solid #000;
                @media screen and (max-width: 575px) {
                    font-size: rem(20px);
                }
            }
            .trow {
                display: table;
                table-layout: fixed;
                border-bottom: 1px solid #000;
                width: 100%;
                background: #fff;
            }
            .trow.head {
            background: #dedfe0;
            color: #000;
            border: 0;
            }
            .th {
            color: #000;
            font-weight: 600;
            text-transform: uppercase;
            }
            .th {
            font-size: 16px;
            font-weight: 700;
            padding: 10px;
            border: 0;
            vertical-align: middle;
            @media screen and (max-width:575px){
                font-size:14px;
            }
            }
            .trow {
            display: table;
            table-layout: fixed;
            border-bottom: 1px solid #000;
            width: 100%;
            background: #fff;
        }
    }
}
    h1 {
        font-size: rem(35px);
        font-weight: 900;
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            font-size: rem(30px);
            margin-bottom:rem(20px);
        }
    }
    h2{
        font-size: rem(35px);
        font-weight: 900;
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            font-size: rem(25px);
            margin-bottom:rem(20px);
        }
    }
    h3{
        font-size: rem(35px);
        font-weight: 900;
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            font-size: rem(25px);
            margin-bottom:rem(20px);
        }
    }
    h4{
        font-size: rem(25px);
        font-weight: 700;
        margin-bottom: rem(15px);
        @media screen and (max-width:767px){
            font-size: rem(20px);
        }
    }
    
    p{
        font-size: rem(18px);
        font-weight: 600;
        color: #707070;
        line-height: 1.3;
        margin-top: 35px;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
        span{
            margin-top: 15px;
            display: inline-block;
        }
    }
    .attendance-status{
        margin-left:0;
        li{
            font-style: italic;
            &:not(:last-child){
                margin-bottom:0;
            }
        }
    }
    .marks{
        max-width: 800px;
        margin: rem(30px) auto;
    }
    ul{
        margin-left: rem(25px);
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            margin-bottom:rem(20px);
        }
        li{
            font-size: rem(18px);
            font-weight: 600;
            color: #707070;
            line-height: 1.3;
            &:not(:last-child){
                margin-bottom:rem(15px);
            }
            @media screen and (max-width:767px){
                font-size:rem(16px);
            }
        }
    }
    ol{
        margin-left: rem(55px);
        margin-bottom:rem(40px);
        @media screen and (max-width:991px){
            margin-left:rem(25px);
        }
        @media screen and (max-width:767px){
            margin-bottom:rem(20px);
        }
        li{
            font-size: rem(18px);
            font-weight: 600;
            color: #707070;
            line-height: 1.3;
            &:not(:last-child){
                margin-bottom: rem(15px);
            }
            @media screen and (max-width:767px){
                font-size:rem(16px);
            }
        }
    }
    .seaGreen{
        color: #00a982;
        font-weight:700;
    }
    .gray{
        color: #707070;
    }
    .bold{
        font-size: rem(18px);
        font-weight: 700;
        line-height: 1.3;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
    }

    // .container{
    //     @media screen and (max-width:1300px) and (min-width:992px){
    //         padding-left:70px;
    //     }
    // }
    @media screen and (max-width:767px){
        .mt-50{
            margin-top:rem(20px) !important;
        }
    }
}
    
[lang="ar"]{
      ul{
        margin-right: rem(25px);
        margin-left:0;
        }
    ol{
        margin-right: rem(55px);
        margin-left:0;
        @media screen and (max-width:991px){
            margin-right:rem(25px);
            margin-left:0;
        }
    }
}

</style>